import React, { useState } from "react";

import { useApi } from "../../../../api";
import I18nText from "../../../../elements/I18nText";
import ConfirmationDialog from "../../../../elements/ConfirmationDialog";
import { AlertButton } from "../../../../elements/Button";
import useI18nSnackbar from "../../../../hooks/useI18nSnackbar";
import { RotateLeft } from "@material-ui/icons";

const ResetContainer = ({ deviceId, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();
  const [isResetting, setResetting] = useState(false);

  const resetSimConnectivity = () => {
    setResetting(true);

    api
      .post(`/v2/devices/${deviceId}/reset-once-sim-connectivity`)
      .then(() => {
        enqueueSnackbar(
          "devices.settings.configuration.responses.onceSimReset",
          {
            variant: "success"
          }
        );
        setResetting(false);
        onClose();
      })
      .catch(_ => {
        enqueueSnackbar(
          "devices.settings.configuration.responses.genericError",
          {
            variant: "error"
          }
        );
        setResetting(false);
        onClose();
      });
  };

  return (
    <ConfirmationDialog
      onCancel={onClose}
      isSubmitting={isResetting}
      ConfirmButton={
        <AlertButton
          disabled={isResetting}
          onClick={resetSimConnectivity}
          icon={<RotateLeft />}
        >
          <I18nText>actions.reset</I18nText>
        </AlertButton>
      }
    >
      <I18nText>
        devices.settings.configuration.onceSimReset.confirmation
      </I18nText>
    </ConfirmationDialog>
  );
};

export default ResetContainer;
